import produce from 'immer';
import { ActionType } from 'typesafe-actions';
import * as equipmentTagsActions from './actions';

export interface EquipmentTagsState {
  tags: string[];
}

const initialState: EquipmentTagsState = {
  tags: [],
};

type EquipmentTagsActions = ActionType<typeof equipmentTagsActions>;

export const equipmentTagsReducer = produce(
  (draft: EquipmentTagsState, action: EquipmentTagsActions) => {
    switch (action.type) {
      case 'SAVE_TAGS': {
        const equipmentTags = action.payload;
        draft.tags = equipmentTags;
        break;
      }
      default:
        break;
    }
  },
  initialState
);
